import React from 'react';

/**
 * Keyboard-only skip navigation link.
 * Visible only on focus for screen-reader & keyboard users.
 */
const SkipNav: React.FC = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-2 focus:rounded-md focus:bg-primary focus:text-primary-foreground focus:outline-none focus:ring-2 focus:ring-ring"
  >
    Skip to main content
  </a>
);

export default SkipNav;
